import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import pathRouts from "../../../../shared/enums/pathRoute";
import Widget from "../../../../shared/components/features/widget/Widget";
import AssignWidgetImg from "../../../../assests/assignStudyGroup/assignWidget.png"
import AssignWidgetImgMobile from "../../../../assests/assignStudyGroup/assignWidgetMobile.png"
import classes from "./AssignWidget.module.css";

const AssignWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <Widget
            color="#D7F8D9"
            mainLink={`/${pathRouts.MYLEARNING}/${pathRouts.ASSIGNSTUDYGTOUP}`}
            className={classes.AssignWidget}
        >
            <div className={classes.AssignContent}>
                <p className={classes.Text}>{texts.assignWidgetTeacher}</p>
                <img src={AssignWidgetImg} alt={texts.assignStudyGroup} className={classes.AssignImg} />
            </div>
            <img src={AssignWidgetImgMobile} alt={texts.assignStudyGroup} className={classes.AssignImgMobile} />
        </Widget>
    );
};

export default AssignWidget;